/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvalDimRatingLevel } from './evalDimRatingLevel';
import type { EvalDimRatingComment } from './evalDimRatingComment';
import type { EvalDimRatingCriteriaEvaluations } from './evalDimRatingCriteriaEvaluations';

/**
 * Rating of a single evaluation dimension
 */
export interface EvalDimRating {
  /** level of performance */
  level?: EvalDimRatingLevel;
  /** comment on and justification of performance */
  comment?: EvalDimRatingComment;
  /** Checklist of specific criteria met/unmet for this dimension. */
  criteriaEvaluations?: EvalDimRatingCriteriaEvaluations;
}
